module.exports = __webpack_public_path__ + "static/media/ctl.4ce84603.png";